import * as Yup from 'yup';
import XRegExp from 'xregexp';

const NAME_EXP = new XRegExp("^[\\&\\.\\(\\)\\-\\+\\,\\'\\s?\\d?\\w+]*$|\\p{Hiragana}\\p{Katakana}\\p{Han}\\p{Hangul}]+");

export default Yup.object().shape({
  name: Yup.string()
    .max(60, 'Must be less than 60 characters')
    .matches(NAME_EXP, "You can only use the following special characters . - ( ) + , ' &")
    .required('Name is required'),
});
